// Copyright (c) 2023-present VexFlow contributors: https://github.com/vexflow/vexflow/graphs/contributors
// MIT License
import { CommonMetrics } from '../src/fonts/common_metrics';
import { LelandFont } from '../src/fonts/leland_glyphs';
export const Font = {
    data: LelandFont,
    metrics: CommonMetrics,
};
export default Font;
